import React from "react";
import {
  Box,
  Typography,
  IconButton,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from "@mui/material";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";

const CustomPagination = ({
  count = 0,
  rowsPerPage = 10,
  page = 0,
  onPageChange,
  onRowsPerPageChange,
  rowsPerPageOptions = [5, 10, 25],
}) => {
  const totalPages = Math.ceil(count / rowsPerPage);
  const startIndex = page * rowsPerPage + 1;
  const endIndex = Math.min((page + 1) * rowsPerPage, count);

  const handleNext = () => {
    if (page + 1 < totalPages) onPageChange(page + 1);
  };

  const handlePrevious = () => {
    if (page > 0) onPageChange(page - 1);
  };

  const handleRowsPerPageChange = (event) => {
    onRowsPerPageChange(event.target.value);
    onPageChange(0); // Reset to first page
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        mt: 1,
        px: 3,
        gap: 2,
        backgroundColor:"#f8f8ff!important"
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
        <Typography variant="body2">{`${startIndex} - ${endIndex} of ${count}`}</Typography>
        <FormControl size="small" variant="outlined" sx={{ minWidth: 120 }}>
          <InputLabel>Rows per page</InputLabel>
          <Select
            value={rowsPerPage}
            onChange={handleRowsPerPageChange}
            label="Rows per page"
          >
            {rowsPerPageOptions.map((option) => (
              <MenuItem key={option} value={option}>
                {option}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>

      <Box sx={{ display: "flex", alignItems: "center" }}>
        <IconButton
          onClick={handlePrevious}
          disabled={page === 0}
          sx={{ color: page === 0 ? "#CFCFCF" : "#4A4C4E" }}
          aria-label="Previous Page"
        >
          <NavigateBeforeIcon />
        </IconButton>
        <Typography variant="body2" sx={{ mx: 2 }}>
          {page + 1} / {totalPages}
        </Typography>
        <IconButton
          onClick={handleNext}
          disabled={page + 1 >= totalPages}
          sx={{ color: page + 1 >= totalPages ? "#CFCFCF" : "#4A4C4E" }}
          aria-label="Next Page"
        >
          <NavigateNextIcon />
        </IconButton>
      </Box>
    </Box>
  );
};

export default CustomPagination;
